export function ensureOriginInString(url: string, newOrigin: string): string {
    const hadTrailingSlash = url.endsWith('/');
    const urlObj = new URL(url, newOrigin);
    if (urlObj.origin !== newOrigin) {
        urlObj.host = new URL(newOrigin).host;
    }
    const result = urlObj.toString();
    if (!hadTrailingSlash && result.endsWith('/')) {
        return result.slice(0, -1);
    }
    return result;
}

export function ensureOriginInRequest(request: Request, newOrigin: string): Request {
    return {
        ...request,
        url: ensureOriginInString(request.url, newOrigin),
    };
}

/** Combines an HTTPS origin and root-relative path without credentials, query, or fragment. */
export function getValidatedHttpsUrl(baseUrl: string, path: string): URL | undefined {
    try {
        const base = new URL(baseUrl);
        const url = new URL(path, base);
        if (
            base.protocol === 'https:' &&
            base.pathname === '/' &&
            !base.username &&
            !base.password &&
            !base.search &&
            !base.hash &&
            path.startsWith('/') &&
            !path.startsWith('//') &&
            !path.includes('\\') &&
            url.origin === base.origin &&
            !url.username &&
            !url.password &&
            !url.search &&
            !url.hash
        ) {
            return url;
        }
    } catch {
        return undefined;
    }
    return undefined;
}
